import {getFixedT} from 'i18next'

// Define the type for romeToJobCodeMapping
type RomeToJobCodeMap = {
  [key: string]: string
}

// Define the mapping of romeId to jobCode.
const romeToJobCodeMapping: RomeToJobCodeMap = {
  A1201: '11607',
  A1203: '16068',
  A1301: '19709',
  A1404: '17402',
  A1407: '14688',
  A1410: '11499',
  A1414: '12117',
  A1416: '10803',
  C1502: '11801',
  D1101: '11564',
  D1102: '11573',
  D1103: '11741',
  D1104: '17576',
  D1105: '17862',
  D1106: '20540',
  D1202: '12688',
  D1208: '14890',
  D1213: '20636',
  D1401: '11210',
  D1402: '11385',
  D1403: '11368',
  D1404: '11254',
  D1406: '38573',
  D1407: '20291',
  D1502: '16338',
  F1102: '11117',
  F1103: '38153',
  F1104: '14020',
  F1106: '15702',
  F1108: '16650',
  F1201: '13209',
  F1202: '12090',
  F1203: '15661',
  F1204: '140879',
  F1301: '15432',
  F1302: '13253',
  F1401: '19772',
  F1402: '11694',
  F1501: '11965',
  F1502: '11492',
  F1503: '11952',
  F1601: '17828',
  F1602: '14635',
  F1603: '17838',
  F1604: '16805',
  F1605: '11621',
  F1606: '17619',
  F1607: '20715',
  F1608: '11690',
  F1609: '19451',
  F1610: '13822',
  F1611: '15029',
  F1613: '11165',
  F1701: '17486',
  F1702: '17597',
  F1703: '16250',
  F1704: '20309',
  F1706: '18036',
  G1203: '11021',
  G1601: '12110',
  G1602: '13861',
  G1603: '14813',
  G1605: '10826',
  G1801: '11494',
  G1802: '16313',
  G1803: '19430',
  G1804: '19452',
  H1101: '20276',
  H1203: '14111',
  H1206: '15602',
  H1208: '20045',
  H1402: '15841',
  H1404: '20202',
  H1501: '15625',
  H1502: '11061',
  H1503: '19711',
  H1504: '13634',
  H1505: '14927',
  H1506: '19797',
  H2101: '11568',
  H2102: '12985',
  H2202: '13056',
  H2206: '16611',
  H2301: '12189',
  H2401: '15239',
  H2402: '16500',
  H2404: '19238',
  H2405: '12182',
  H2406: '13041',
  H2407: '13087',
  H2408: '13046',
  H2409: '13785',
  H2410: '17099',
  H2411: '16855',
  H2412: '17336',
  H2413: '17141',
  H2414: '15464',
  H2415: '13622',
  H2501: '11019',
  H2502: '15605',
  H2503: '19716',
  H2504: '12521',
  H2505: '12441',
  H2601: '11542',
  H2602: '14633',
  H2603: '13001',
  H2604: '17086',
  H2605: '16875',
  H2701: '20134',
  H2801: '15083',
  H2802: '13283',
  H2803: '19759',
  H2804: '19901',
  H2805: '20152',
  H2901: '10907',
  H2902: '20356',
  H2903: '20383',
  H2904: '17172',
  H2905: '16244',
  H2906: '13038',
  H2907: '13279',
  H2908: '12043',
  H2909: '17154',
  H2910: '12479',
  H2911: '18023',
  H2912: '18435',
  H2913: '19476',
  H2914: '12103',
  H3101: '13026',
  H3102: '18006',
  H3301: '12184',
  H3302: '17180',
  H3303: '12893',
  H3401: '15089',
  H3402: '17177',
  H3403: '17299',
  H3404: '18200',
  I1301: '11164',
  I1302: '19862',
  I1303: '38328',
  I1304: '19870',
  I1305: '19838',
  I1306: '20010',
  I1307: '19866',
  I1308: '19837',
  I1309: '14637',
  I1310: '16535',
  I1401: '19822',
  I1402: '18526',
  I1604: '16446',
  I1606: '11701',
  I1607: '16549',
  J1301: '10472',
  J1304: '11448',
  J1306: '20074',
  J1405: '17353',
  J1501: '10891',
  J1502: '38859',
  J1506: '15545',
  K1102: '38388',
  K1202: '14586',
  K1207: '16740',
  K1301: '140948',
  K1302: '11453',
  K1303: '11455',
  K1304: '10805',
  K1403: '14399',
  K2201: '16237',
  K2203: '15983',
  K2204: '10688',
  K2301: '19726',
  K2304: '10629',
  K2305: '20166',
  K2306: '20132',
  K2402: '11855',
  K2502: '12336',
  K2503: '10557',
  K2601: '12426',
  K2602: '13461',
  M1101: '10241',
  M1203: '12786',
  M1403: '11905',
  M1609: '19397',
  M1801: '200112',
  M1802: '14963',
  M1803: '14386',
  M1804: '18822',
  M1805: '15823',
  M1806: '15321',
  M1810: '10945',
  N1101: '11679',
  N1102: '13948',
  N1103: '16276',
  N1104: '18317',
  N1105: '10579',
  N1201: '10336',
  N1202: '13696',
  N1301: '19112',
  N1302: '13682',
  N1303: '20181',
  N3201: '18993',
  N3202: '11168',
  N3203: '12267',
  N4101: '13324',
  N4103: '12896',
  N4201: '18619',
  N4203: '19986',
  N4204: '11273',
  // ... add other mappings as needed.
}

// TODO(cyrille): Use this for CPF too.
export default (job: ValidUpskillingJob, city: bayes.bob.FrenchCity): Promise<string> => {
  const interpolate = getFixedT(config.defaultLang)
  const {jobGroup: {
    romeId,
    name: jobGroupName,
    samples: [{name: jobName = ''} = {}] = [],
  } = {}} = job

  // Retrieve jobCode from the mapping using romeId.
  const jobCode = romeId && romeToJobCodeMapping[romeId]
  const {cityId, departementName, latitude, longitude, name: cityName = ''} = city

  const immerseLinkTemplate = 'https://immersion-facile.beta.gouv.fr/recherche?distanceKm=10&latitude={{latitude}}&longitude={{longitude}}&appellations=%5B%7B%22romeCode%22%3A%22{{romeId}}%22%2C%22romeLabel%22%3A%22{{jobGroupName}}%22%2C%22appellationCode%22%3A%22{{jobCode}}%22%2C%22appellationLabel%22%3A%22{{jobName}}%22%7D%5D&sortedBy=distance&place={{cityName}}%2C%20{{departementName}}%2C%20France'
  // const immerseLinkTemplate = 'https://immersion-facile.beta.gouv.fr/recherche?distanceKm=10&latitude={{latitude}}&longitude={{longitude}}&appellations=%5B%7BromeCode="{{romeId}}"%2C"romeLabel"%3A"{{jobGroupName}}"%2C"appellationCode"%3A"{{jobCode}}"%2C"appellationLabel"%3A"{{jobName}}"%7D%5D&sortedBy=distance&place={{cityName}}%2C%20{{departementName}}%2C%20France'

  // i18next-extract-disable-next-line
  return Promise.resolve(interpolate(immerseLinkTemplate, {
    cityId,
    cityName: encodeURIComponent(cityName),
    departementName,
    jobCode,
    jobGroupName,
    jobName: encodeURIComponent(jobName),
    latitude,
    longitude,
    romeId,
  }))
}
